import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { IMenuOption } from '../interfaces/menu-option.interface';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private readonly menuOptions: IMenuOption[] = [
        { label: 'DIGITALIZAR FACTURA', path: '/digitalize-invoice' },
        { label: 'RESUMEN', path: '/resume' },
        { label: 'AÑADIR FACTURA QR', path: '/add-qr' },
        { label: 'AÑADIR CONTACTO QR', path: '/add-qr' },
        { label: 'MI QR', path: '/mi-qr' },
        { label: 'SUBIR DOCUMENTO', path: '/upload-document' },
        { label: 'LISTA DE DOCUMENTOS', path: '/list-documents' },
    ];

    constructor(
        private router: Router,
        private menuCtrl: MenuController
    ) { }

    getMenuOptions(): IMenuOption[] {
        return this.menuOptions;
    }

    async navigateTo(path: string, menuId?: string) {
        console.log('Acceso a la ruta:', path);

        if (menuId) {
            await this.menuCtrl.close(menuId);
        }

        this.router.navigate([path], { replaceUrl: true });
    }

    async closeMenu(menuId: string) {
        await this.menuCtrl.close(menuId);
    }
}
